<template>
  <div class="Settlement">
    <div class="headContent">
      <div class="classTitle">
        <img
          src="@/assets/collect/hadeTitle@2x.png"
          alt=""
        >
      </div>
    </div>
    <div class="contentBox">
      <img
        v-if="info.detail.payStatus && info.detail.payStatus != 1"
        class="payStatusTag"
        :src="require(`@/assets/collect/${info.detail.payStatus}icon.png`)"
        alt=""
      >
      <div class="content">
        <div class="item">
          <div class="label">
            收款项目：
          </div>
          <div class="labelText">
            {{ info.detail.itemName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            姓名：
          </div>
          <div class="labelText">
            {{ info.detail.authName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            手机号：
          </div>
          <div class="labelText">
            {{ info.detail.mobile }}
          </div>
        </div>
        <div v-if="$route.query.type == 'stages'">
          <div class="item">
            <div class="label">
              还款金额：
            </div>
            <div class="labelText">
              {{ price.resume(info.detail.itemPrice) }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              还款日期：
            </div>
            <div class="labelText">
              {{ info.detail.repaidDate }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              剩余欠费金额：
            </div>
            <div class="labelText">
              {{ price.resume(info.detail.remainPrice) }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="item">
            <div class="label">
              订单编号：
            </div>
            <div class="labelText">
              {{ info.detail.orderNumber }}
            </div>
          </div>
          <div class="item">
            <div class="label">
              下单时间：
            </div>
            <div class="labelText">
              {{ info.detail.createdTime }}
            </div>
          </div>
        </div>
        <div
          v-if="info.detail.payStatus== 2"
          class="item"
        >
          <div class="label">
            支付时间：
          </div>
          <div class="labelText">
            {{ info.detail.payedTime }}
          </div>
        </div>
        <div
          v-if="info.detail.payStatus != 1 && info.detail.tradeNo"
          class="item"
        >
          <div class="label">
            交易单号：
          </div>
          <div class="labelText">
            {{ info.detail.tradeNo }}
          </div>
        </div>
        <div
          v-if="info.detail.payStatus!= 1&&info.detail.payStatus!= 0 && info.detail.channelTypeId!=38 && info.detail.channelTypeId!=7"
          class="item"
        >
          <div class="label">
            支付渠道：
          </div>
          <div class="labelText">
            {{ info.detail.channelTypeName }}
          </div>
        </div>
        <template v-if="info.detail.channelTypeId==7 || info.detail.channelTypeId==38 || info.detail.channelTypeId==64|| info.detail.channelTypeId==65">
          <div class="item">
            <div class="label">
              分期平台：
            </div>
            <div class="labelText">
              {{ info.detail.channelTypeName }}
            </div>
          </div>
          <div
            v-if="info.detail.channelTypeId==7 || info.detail.channelTypeId==64 || info.detail.channelTypeId==65"
            class="item"
          >
            <div class="label">
              分期期数：
            </div>
            <div class="labelText">
              {{ info.detail.channelStage }}
            </div>
          </div>
        </template>
             
        <div class="price flexBox h-center">
          {{ (info.detail.channelTypeId==38 || info.detail.channelTypeId==7 || info.detail.channelTypeId==64 || info.detail.channelTypeId==65)?'分期金额：':"应付金额：" }}<span>{{ price.resume(info.detail.itemPrice) }}元</span>
        </div>
      </div>
    </div>
    <div
      v-if="info.detail.payStatus== 1"
      class="payButton"
      @click="showPay"
    >
      {{ (info.detail.channelTypeId==38 || info.detail.channelTypeId==7 || info.detail.channelTypeId==64 || info.detail.channelTypeId==65)?'立即办理分期':'立即支付' }}
    </div>
    <div
      v-else
      class="success flexBox h-center"
    >
      <img
        v-if="info.detail.payStatus"
        :src="require(`@/assets/collect/${info.detail.payStatus}.png`)"
        alt=""
      >
      <div>
        {{ info.payStatus[info.detail.payStatus] }}
      </div>
    </div>
  </div>
  <footer>
    <div>哈德（厦门）教育集团有限公司</div>
    <div>客服电话：4008-163-998</div>
  </footer>
  <Pay
    :order-number="info.orderNumber"
    :return-url="info.returnUrl"
    :params="{channelTypeId:info.detail.channelTypeId}"
    :show-type="showType()"
  />
</template>
<script>
import Pay from '@/components/payComment/payIndex.vue'
import {wxUtil} from '@/utils/wx_util'
import {
  defineComponent,
  onMounted,
  onUpdated,
  onUnmounted,
  reactive,
} from 'vue'
// import { Dialog, } from 'vant';
import { useRoute } from "vue-router";
import {useStore} from 'vuex'
import {orderDetail,orderStageDetail,orderInstallmentDetail } from  '@/api/order'
import {zswlPay, haierPay, psbcPay, msPay, haierxjPay, xydPay, huabeidPay, shouqianbaPay} from '@/api/pay'
import {handleDebounce} from "@/utils/tools"
import price from "@/utils/price";
import {Toast} from "vant";
export default defineComponent({
  name: 'Settlement',
  components: {
     Pay
  },
  props: {},
  setup() {
    // const router = useRouter()
    const route = useRoute();
    const store = useStore()
    store.commit('hidePaying')
    //表单数据
    let info = reactive({
        hasPay:route.query.hasPay,
        orderNumber:route.query.orderNumber,
        detail:{},
        returnUrl:location.href,
        payStatus:{
             0:'订单已取消', 1:'待支付', 2:'支付成功', 3:'退款申请中...', 4:'退款中...', 5:'已退款'
        },
        payType:{1:'微信', 2:'支付宝', 3:'虚拟币支付', 4:'苹果支付', 5:'学习卡兑换', 6:'赠送', 7:'优惠券支付', 8:'线下支付', 9:'积分兑换', 10:'免费'}
    })
    // 生命周期
    onMounted(async () => {
      let request =  route.query.type=='stages'?orderStageDetail:route.query.type=='installment'?orderInstallmentDetail:orderDetail
      info.detail = await request(
          info.orderNumber
      )
    })
 
    const showPay = handleDebounce(async ()=>{
        if(info.detail['channelTypeId']==38 || info.detail['channelTypeId']==7 || info.detail['channelTypeId']==43||info.detail['channelTypeId']==56 || info.detail['channelTypeId']==63 || info.detail['channelTypeId']==64||info.detail['channelTypeId']==69){
            let data = null
            //芝士分期
            if(info.detail['channelTypeId']==38){
                data = await zswlPay({
                    "tagType": 4,
                    "orderNumber": info.orderNumber
                })
                
            }else if(info.detail['channelTypeId']==43){
                //邮储在线
                data = await psbcPay({
                    "tagType": 4,
                    "orderNumber": info.orderNumber,
                    returnUrl:location.href
                })
            }else if(info.detail['channelTypeId']==56){
              //民生银行
              data = await msPay({
                    "tagType": 4,
                    'channelCode':wxUtil.checkIsInWx()?'WX':'ALI',
                    "orderNumber": info.orderNumber,
                    returnUrl:location.href
                })
                console.log(data)
            }else if(info.detail['channelTypeId']==63){
              //海尔消金
              data = await haierxjPay({
                    "tagType": 4,
                    "orderNumber": info.orderNumber,
                })
            } else if(info.detail['channelTypeId']==64){
              //小雨点
              data = await xydPay({
                "tagType": 4,
                "orderNumber": info.orderNumber,
              })
            }else if(info.detail['channelTypeId']==69){
              //收钱吧
              data = await shouqianbaPay({
                "tagType": 4,
                "orderNumber": info.orderNumber,
                returnUrl:location.href
              })
              console.log(data)
            }
            else{
                data = await haierPay({
                    "tagType": 4,
                    "orderNumber": info.orderNumber
                })
            }
            window.open(data['body'])
        }else{
          if(info.detail['channelTypeId']==65){
            //花呗
            let data = await huabeidPay({
              "tagType": 4,
              "orderNumber": info.orderNumber,
            })
            aliPay(data)
          } else {
            store.commit('showPaying')
          }
        }
    },500) 

    const showType = ()=>{
      if(wxUtil.checkIsInWx()){
        return [1]
      }else if(wxUtil.checkIsInAli()){
        return [2]
      }else{
        return [1,2]
      }
    }
    const aliPay = (res)=>{
      // 阿里支付
      const div = document.createElement('div')
      div.classList = 'ali-form'
      if (res.body) {
        div.innerHTML = res.body
        document.body.appendChild(div)
        const form = document.querySelector('.ali-form form')
        form.submit()
      } else {
        Toast('支付失败')
        location.reload()
      }
    }
    // 暴露给模板
    return {
      showPay,
      info,
      price,
      showType
    }
  },
  computed: {},
})
</script>
<style lang="less" scoped>
    .c-999{
        color:#999;
    }
    .Settlement{
        background: #F8F8F8;
        height:90vh;
        // overflow-y: scroll;
    }
    .plan{
        position: fixed;
        top:0;
        left:0;
        right:0;
         z-index:10;
        height: 50px;
        padding:0 20px;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        line-height: 50px;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        .rightAngle{
            width:12px;
        }
    }
    .headContent{
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:400px;
        background-image: url("~@/assets/collect/settlebgNew.png");
        background-size:100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        z-index:0;
        .classTitle{
            font-size: 44px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 62px;
            margin:84px auto 0 auto;
            img{
                width:456px;
            }
        }
    }
    .contentBox{
        position: relative;
        z-index:1;
        margin:200px 40px 0 40px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 12px;
        .payStatusTag{
            position: absolute;
            right:0;
            top:0;
            width: 98px;
            z-index:2;
        }
        .paymentTime{
            color: #FFFFFF;
            padding:20px 40px;
            border-radius: 10px 10px 0px 0px;
           
            h5{
                margin:0;
                font-size: 32px;
            }
            .remaining{
                margin-top:6px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF
            }

        }
         .content{
            padding:10px 40px;

            position: relative;
            z-index:1;
            background:#fff;
            border-radius: 10px;
            z-index:1;
            .item{
                display:flex;
                justify-content: space-between;
                align-items: flex-start;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;   
                margin:35px 0;
                
                .label{
                    color: #333333;
                    line-height: 40px;
                    width:150px;
                    white-space:nowrap; 
                }
                .labelText{
                    color: #666666;
                    text-align: right;
                    white-space: normal;
                    word-break: break-all;
                }
            }
            .price{
                padding:35px 0;
                text-align: center;
                font-size: 28px;
                border-top: 1px solid #EAEAEA;
            
                span{
                    display: inline-block;
                    font-size: 44px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FF5C4B;
                }
            }
        }
    }
    .payButton{
        margin:50px auto;
        width: 500px;
        height: 80px;
        line-height:80px;
        background: #157CFF;
        border-radius: 40px;
        color:#fff;
        font-size:32px;
        text-align: center;
    }
   
    .hasSelect{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #157CFF;
        line-height: 40px;
        margin:23px auto 26px auto;
        text-align: center;
    }
    .cardContent{
        padding:0px 40px 0 40px;
        margin-bottom:120px;
     
    }

    .footBtm{
        position: fixed;
        bottom:0;
        left:0;
        right:0;
        height:120px;
        padding:0px 30px 20px 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background:#fff;
        box-shadow: 0px -1px 1px 0px rgba(0, 0, 0, 0.06);
        z-index:10;
        .foottext{
            .submitMoney{
               .symbol{
                   display: inline-block;
                   color: #333333;
                   font-size: 28px;
               }
                .yingfu{
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 40px;
                    height: 40px;
                    margin-right:20px;
                }
                .money{
                    font-size: 44px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bolder;
                    color: #FF5C4B;
                    line-height: 50px;
                }
            }
           
        }
        .hasSelectTip{
                height: 33px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF7023;
                line-height: 33px;
                margin-top:3px;
            }
        .submit{
            padding:0 50px;
            height: 80px;
            line-height: 80px;
            border-radius: 40px; 
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bolder;
        }
        .toSubmit{
            background: #157CFF;
            color: #FFFFFF;
        }
         .cancelSubmit{
            background: #FFFFFF;
            color: #333333;
            border: 1px solid #CCCCCC;
            margin-right:20px;
        }
    }
    .flexEnd{
        display: flex;
        align-items: flex-end;
    }
    footer{
        position:fixed;
        bottom:20px;
        left:0;
        right:0;
        text-align: center;
        
        div{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 38px;
        }
    }
    .success{
        img{
            width:100px;
            margin-right:28px;
        }
        font-size: 44px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #157CFF;
        height: 180px;
        margin:30px 40px;
        text-align: center;
        background: #EDF3FF;
        border-radius: 10px;
    }
   
</style>